import { plural } from "../../design/format/numbers.ts";

export const creativeWatchCopy = {
  pista: {
    conjunto: "pede criativos",
    campanha: (n: number) => `${n} ${plural(n, "conjunto pede", "conjuntos pedem")} criativos`,
  },
  titulo: "Pede criativos",
  poucos: (no: number, minimo: number) => {
    const ar = no === 0 ? "Nenhum anúncio" : `${no} ${plural(no, "anúncio", "anúncios")}`;
    return `${ar} no ar, e a empresa pede ao menos ${minimo} por conjunto.`;
  },
  frequencia: (frequencia: string, limite: string) =>
    `As mesmas pessoas viram os anúncios ${frequencia} vezes nos últimos 7 dias, acima do limite de ${limite} da empresa.`,
  pedido: "Peça criativos novos à equipe para este conjunto. É uma pista, não um alerta: a Nabla não muda nada por ela.",
  minimoNoAr: { nome: "mínimo de anúncios no ar", um: "anúncio", varios: "anúncios" },
} as const;
